export default "__VITE_ASSET__D_6N0cIg__"